module.exports = __webpack_public_path__ + "img/icon-device-tablet.9beffd25.svg";